import React from 'react'
import styled from 'styled-components'
import { media, colors } from '../styles/vars'


const Container = styled.a`
display:inline-block;
position:relative;
cursor:pointer;
width:40px;
height:40px;
border-radius:50%;
background-color:${colors.purple};
color:#fff;
margin-left:10px;
${props => props.botMargin ? 'margin:0 auto 9px' : ''};
display:${props => props.desktopOnly ? 'none' : 'inline-block'};
${
    media.desktop`
    display:${props => props.mobileOnly ? 'none' : 'inline-block'};
    ${props => props.botMargin ? 'margin: 0 0 0 10px' : ''};
    `
    }
`
const ShareIconImg = styled.img`
position:absolute;
left:0;
bottom:0;
right:0;
top:0;
margin:auto;
max-width:50%;
filter:${props => props.white ? 'invert(100%)' : 'unset'};
`
const ShareIcon = (props) => {
    return (
        <Container
            onClick={props.onClick}
            href={props.href}
            mobileOnly={props.mobileOnly}
            desktopOnly={props.desktopOnly}
            botMargin={props.botMargin}
            target={props.self ? '_self' : '_blank'}
            rel={props.self ? '' : 'noopener noreferrer'}
            {...props.customAttrs}
        >
            <ShareIconImg src={props.imageSrc} white={props.white} />
        </Container>
    )
}

export default ShareIcon;


// WEBPACK FOOTER //
// ./src/components/ShareIcon.jsx